import "./App.css";
import Navbar from "./component/Navbar";
import Navigation from "./routes/Navigation";
import { useEffect } from "react";

function App() {

  // useEffect(() => {
  //   const disableRightClick = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", disableRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", disableRightClick);
  //   };
  // }, []);

  return (
    <div className='App'>
      <Navbar />
      <Navigation />
    </div>
  );
}

export default App;
